"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WARRANTY_CANCELED = exports.VEHICLE_STOLEN = exports.VEHICLE_REBUILD = exports.VEHICLE_PURCHASE = exports.VEHICLE_CONDITION = exports.Trade360ToDeskingAnswersMapper = exports.TRUE_DISTANCE_TRAVELED = exports.TRUE_DISTANCE = exports.SUITABLE_TRANSPORTATION = exports.STRUCTURAL_DAMAGE = exports.RUST_PROOF = exports.REPLACED_TIRES = exports.REPLACED_BRAKES = exports.RECALL = exports.PARTS_TO_REPLACE = exports.OUTSIDE_REGISTRY = exports.ORIGINAL_OWNER = exports.OPEN_NOTICES = exports.NEED_REPARATION_OTHER_EXPLANATION = exports.MECHANICAL_PROTECTION = exports.MAJOR_EXTERIOR_INTERIOR_DAMAGE = exports.FOR_RESALE = exports.FIRE_DAMAGE = exports.DAMAGE_EXCEEDING_3000 = exports.COVERAGE_BALANCE = exports.CORPORATE_USE_EXPLANATION = exports.CORPORATE_USE = exports.COMPLIES_REQUIREMENT = exports.CLARIFY_REGISTRY = exports.CLARIFY_OPEN_NOTICES = exports.CLARIFY_DAMAGE = exports.CLARIFY_ACCIDENT = exports.BODY_PART_REPLACED = exports.AIR_BAGS_OPERATIONAL = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = require("lodash");

var _questions4, _questions6, _questions10, _questions12, _questions13;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ORIGINAL_OWNER = 'originalOwner';
exports.ORIGINAL_OWNER = ORIGINAL_OWNER;
var VEHICLE_PURCHASE = 'vehiclePurchase';
exports.VEHICLE_PURCHASE = VEHICLE_PURCHASE;
var VEHICLE_CONDITION = 'vehicleCondition';
exports.VEHICLE_CONDITION = VEHICLE_CONDITION;
var CORPORATE_USE = 'corporateUse';
exports.CORPORATE_USE = CORPORATE_USE;
var CORPORATE_USE_EXPLANATION = 'corporateUseExplanation';
exports.CORPORATE_USE_EXPLANATION = CORPORATE_USE_EXPLANATION;
var RUST_PROOF = 'rustProof';
exports.RUST_PROOF = RUST_PROOF;
var MECHANICAL_PROTECTION = 'mechanicalProtection';
exports.MECHANICAL_PROTECTION = MECHANICAL_PROTECTION;
var COVERAGE_BALANCE = 'coverageBalance';
exports.COVERAGE_BALANCE = COVERAGE_BALANCE;
var TRUE_DISTANCE = 'trueDistance';
exports.TRUE_DISTANCE = TRUE_DISTANCE;
var TRUE_DISTANCE_TRAVELED = 'trueDistanceTraveled';
exports.TRUE_DISTANCE_TRAVELED = TRUE_DISTANCE_TRAVELED;
var DAMAGE_EXCEEDING_3000 = 'damageExceeding3000';
exports.DAMAGE_EXCEEDING_3000 = DAMAGE_EXCEEDING_3000;
var CLARIFY_ACCIDENT = 'clarifyAccident';
exports.CLARIFY_ACCIDENT = CLARIFY_ACCIDENT;
var VEHICLE_REBUILD = 'vehicleRebuild';
exports.VEHICLE_REBUILD = VEHICLE_REBUILD;
var AIR_BAGS_OPERATIONAL = 'airBagsOperational';
exports.AIR_BAGS_OPERATIONAL = AIR_BAGS_OPERATIONAL;
var FIRE_DAMAGE = 'fireDamage';
exports.FIRE_DAMAGE = FIRE_DAMAGE;
var VEHICLE_STOLEN = 'vehicleStolen';
exports.VEHICLE_STOLEN = VEHICLE_STOLEN;
var STRUCTURAL_DAMAGE = 'structuralDamage';
exports.STRUCTURAL_DAMAGE = STRUCTURAL_DAMAGE;
var BODY_PART_REPLACED = 'bodyPartReplaced';
exports.BODY_PART_REPLACED = BODY_PART_REPLACED;
var OPEN_NOTICES = 'openNotices';
exports.OPEN_NOTICES = OPEN_NOTICES;
var CLARIFY_OPEN_NOTICES = 'clarifyOpenNotices';
exports.CLARIFY_OPEN_NOTICES = CLARIFY_OPEN_NOTICES;
var PARTS_TO_REPLACE = 'partsToReplace';
exports.PARTS_TO_REPLACE = PARTS_TO_REPLACE;
var NEED_REPARATION_OTHER_EXPLANATION = 'needReparationOtherExplanation';
exports.NEED_REPARATION_OTHER_EXPLANATION = NEED_REPARATION_OTHER_EXPLANATION;
var REPLACED_TIRES = 'replacedTires';
exports.REPLACED_TIRES = REPLACED_TIRES;
var REPLACED_BRAKES = 'replacedBrakes';
exports.REPLACED_BRAKES = REPLACED_BRAKES;
var MAJOR_EXTERIOR_INTERIOR_DAMAGE = 'majorExteriorInteriorDamage';
exports.MAJOR_EXTERIOR_INTERIOR_DAMAGE = MAJOR_EXTERIOR_INTERIOR_DAMAGE;
var CLARIFY_DAMAGE = 'clarifyDamage';
exports.CLARIFY_DAMAGE = CLARIFY_DAMAGE;
var OUTSIDE_REGISTRY = 'outsideRegistry';
exports.OUTSIDE_REGISTRY = OUTSIDE_REGISTRY;
var CLARIFY_REGISTRY = 'clarifyRegistry';
exports.CLARIFY_REGISTRY = CLARIFY_REGISTRY;
var FOR_RESALE = 'forResale';
exports.FOR_RESALE = FOR_RESALE;
var WARRANTY_CANCELED = 'warrantyCanceled';
exports.WARRANTY_CANCELED = WARRANTY_CANCELED;
var COMPLIES_REQUIREMENT = 'compliesRequirement';
exports.COMPLIES_REQUIREMENT = COMPLIES_REQUIREMENT;
var SUITABLE_TRANSPORTATION = 'suitableTransportation';
exports.SUITABLE_TRANSPORTATION = SUITABLE_TRANSPORTATION;
var RECALL = 'recall';
exports.RECALL = RECALL;
var yesNoChoices = [{
  value: true,
  labelKey: 'QUESTIONNAIRE.YES'
}, {
  value: false,
  labelKey: 'QUESTIONNAIRE.NO'
}];
var history = {
  questions: (_questions4 = {}, (0, _defineProperty2.default)(_questions4, ORIGINAL_OWNER, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.ORIGINALOWNER',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions4, VEHICLE_PURCHASE, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLEPURCHASE',
    choices: [{
      value: 'private',
      labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLEPURCHASE_PRIVATE'
    }, {
      value: 'dealer',
      labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLEPURCHASE_DEALER'
    }]
  }), (0, _defineProperty2.default)(_questions4, VEHICLE_CONDITION, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLECONDITION',
    choices: [{
      value: 'perfect',
      labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLECONDITION_PERFECT'
    }, {
      value: 'ok',
      labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLECONDITION_OK'
    }, {
      value: 'rough',
      labelKey: 'QUESTIONNAIRE.HISTORY.VEHICLECONDITION_ROUGH'
    }]
  }), (0, _defineProperty2.default)(_questions4, CORPORATE_USE, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.CORPORATEUSE',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, CORPORATE_USE_EXPLANATION, {
      showQuestionText: false,
      linkToParent: {
        onlyFor: true
      },
      displayNestedInsideParent: true,
      type: 'textarea',
      labelKey: 'QUESTIONNAIRE.HISTORY.CORPORATEUSEEXPLANATION'
    })
  }), (0, _defineProperty2.default)(_questions4, RUST_PROOF, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.RUSTPROOF',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions4, MECHANICAL_PROTECTION, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.MECHANICALPROTECTION',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, COVERAGE_BALANCE, {
      linkToParent: {
        onlyFor: true
      },
      labelKey: 'QUESTIONNAIRE.HISTORY.COVERAGEBALANCE',
      type: 'textarea'
    })
  }), (0, _defineProperty2.default)(_questions4, TRUE_DISTANCE, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.HISTORY.TRUEDISTANCE',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, TRUE_DISTANCE_TRAVELED, {
      linkToParent: {
        onlyFor: false
      },
      labelKey: 'QUESTIONNAIRE.HISTORY.DISTANCEBALANCE',
      type: 'textarea'
    })
  }), _questions4)
};
var susDamage = {
  questions: (_questions6 = {}, (0, _defineProperty2.default)(_questions6, DAMAGE_EXCEEDING_3000, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.CONDITION.DAMAGEEXCEEDING3000',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, CLARIFY_ACCIDENT, {
      linkToParent: {
        onlyFor: true
      },
      displayNestedInsideParent: true,
      type: 'textarea',
      labelKey: 'QUESTIONNAIRE.CONDITION.CLARIFYDAMAGE'
    })
  }), (0, _defineProperty2.default)(_questions6, VEHICLE_REBUILD, {
    labelKey: 'QUESTIONNAIRE.VEHICLEREBUILD',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions6, AIR_BAGS_OPERATIONAL, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.CONDITION.AIRBAGSOPERATIONAL',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions6, FIRE_DAMAGE, {
    labelKey: 'QUESTIONNAIRE.FIREDAMAGE',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions6, VEHICLE_STOLEN, {
    labelKey: 'QUESTIONNAIRE.VEHICLESTOLEN',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions6, STRUCTURAL_DAMAGE, {
    labelKey: 'QUESTIONNAIRE.STRUCTURALDAMAGE',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions6, BODY_PART_REPLACED, {
    labelKey: 'QUESTIONNAIRE.PANELREPLACED',
    type: 'radio',
    choices: yesNoChoices
  }), _questions6)
};
var repairsRequired = {
  questions: (_questions10 = {}, (0, _defineProperty2.default)(_questions10, OPEN_NOTICES, {
    labelKey: 'QUESTIONNAIRE.OPENNOTICE',
    type: 'radio',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, CLARIFY_OPEN_NOTICES, {
      linkToParent: {
        onlyFor: true
      },
      labelKey: 'QUESTIONNAIRE.CONDITION.CLARIFYDAMAGE',
      type: 'textarea'
    })
  }), (0, _defineProperty2.default)(_questions10, PARTS_TO_REPLACE, {
    type: 'checkbox',
    labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE',
    choices: [{
      value: 'none',
      disableOthers: true,
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_NONE'
    }, {
      value: 'engineTransmissionPowertrain',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_ENGINETRANSPOWER'
    }, {
      value: 'suspension',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_SUSPENSION'
    }, {
      value: 'computer',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_COMPUTER'
    }, {
      value: 'electrical',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_ELECTRICAL'
    }, {
      value: 'fuelOperationSystem',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_FUELOPERATIONSYSTEM'
    }, {
      value: 'airConditioningSystem',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_AIRCONDITIONINGSYSTEM'
    }, {
      value: 'abs',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_ABS'
    }, {
      value: 'other',
      labelKey: 'QUESTIONNAIRE.CONDITION.PARTSTOREPLACE_OTHER'
    }],
    questions: (0, _defineProperty2.default)({}, NEED_REPARATION_OTHER_EXPLANATION, {
      linkToParent: {
        anyExcept: 'none'
      },
      displayNestedInsideParent: true,
      type: 'textarea',
      labelKey: 'QUESTIONNAIRE.CONDITION.NEEDREPARATIONOTHEREXPLANATION'
    })
  }), (0, _defineProperty2.default)(_questions10, REPLACED_TIRES, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.CONDITION.REPLACEDTIRES',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions10, REPLACED_BRAKES, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.CONDITION.REPLACEDBRAKES',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions10, MAJOR_EXTERIOR_INTERIOR_DAMAGE, {
    type: 'radio',
    labelKey: 'QUESTIONNAIRE.CONDITION.MAJOREXTERIORINTERIORDAMAGE',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, CLARIFY_DAMAGE, {
      linkToParent: {
        onlyFor: true
      },
      displayNestedInsideParent: true,
      type: 'textarea',
      labelKey: 'QUESTIONNAIRE.CONDITION.CLARIFYDAMAGE'
    })
  }), _questions10)
};
var registration = {
  questions: (_questions12 = {}, (0, _defineProperty2.default)(_questions12, OUTSIDE_REGISTRY, {
    labelKey: 'QUESTIONNAIRE.OUTSIDEREGISTRY',
    type: 'radio',
    choices: yesNoChoices,
    questions: (0, _defineProperty2.default)({}, CLARIFY_REGISTRY, {
      linkToParent: {
        onlyFor: true
      },
      displayNestedInsideParent: true,
      type: 'textarea',
      labelKey: 'QUESTIONNAIRE.CLARIFYREGISTRY'
    })
  }), (0, _defineProperty2.default)(_questions12, FOR_RESALE, {
    labelKey: 'QUESTIONNAIRE.FORRESALE',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions12, WARRANTY_CANCELED, {
    labelKey: 'QUESTIONNAIRE.WARRANTLYCANCELED',
    type: 'radio',
    choices: yesNoChoices
  }), _questions12)
};
var addDisclosures = {
  questions: (_questions13 = {}, (0, _defineProperty2.default)(_questions13, COMPLIES_REQUIREMENT, {
    labelKey: 'QUESTIONNAIRE.COMPLIESREQUIREMENT',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions13, SUITABLE_TRANSPORTATION, {
    labelKey: 'QUESTIONNAIRE.SUITABLETRANSPORTATION',
    type: 'radio',
    choices: yesNoChoices
  }), (0, _defineProperty2.default)(_questions13, RECALL, {
    labelKey: 'QUESTIONNAIRE.RECALL',
    type: 'radio',
    choices: yesNoChoices
  }), _questions13)
};

var Trade360ToDeskingAnswersMapper = function Trade360ToDeskingAnswersMapper(answers) {
  var corporateUse = answers.corporateUse,
      hasUsed = answers.hasUsed,
      hadAnAccident = answers.hadAnAccident,
      partsToReplace = answers.partsToReplace,
      panelReplaced = answers.panelReplaced,
      absOperational = answers.absOperational,
      majorExteriorInteriorDamage = answers.majorExteriorInteriorDamage,
      anyScratches = answers.anyScratches;

  var adjsutedAnswers = _objectSpread({}, answers); // corporateUse (Vehicle used as taxi, police, etc..)
  // since corporateUse is present in Trade360 and prior to this hasUsed never made it into Desking production
  // (or did but for only a week)
  // we will use enforce corporateUse first


  if ((0, _lodash.isEmpty)(corporateUse) && !(0, _lodash.isEmpty)(hasUsed)) {
    adjsutedAnswers[CORPORATE_USE] = true;
  }

  if (typeof panelReplaced !== 'undefined' && panelReplaced !== '') {
    adjsutedAnswers[BODY_PART_REPLACED] = panelReplaced;
    adjsutedAnswers.panelReplaced = '';
  } // damageExceeding3000
  // damageExceeding3000 never made it into Desking production prior the time of this update
  // this part is a little tricky, we are always enforcing damageExceeding3000 to be the new source
  // to not allow for this to get mixed up we immediately erase hadAnAccident coming from Trade360
  // so if Desking decides to change the value for damageExceeding3000 we won't have it overriden by hadAnAccident


  if (!(0, _lodash.isEmpty)(hadAnAccident)) {
    adjsutedAnswers[DAMAGE_EXCEEDING_3000] = !!(hadAnAccident === 'lessThan3000' || hadAnAccident === '3000AndMore');
    adjsutedAnswers.hadAnAccident = ''; // this will erase the Trade360 side answer
  }

  if (!(0, _lodash.isEmpty)(partsToReplace) && partsToReplace.find(function (part) {
    return part === 'engine' || part === 'transmission' || part === 'powertrain';
  })) {
    adjsutedAnswers[PARTS_TO_REPLACE].push('engineTransmissionPowertrain');
    adjsutedAnswers[PARTS_TO_REPLACE] = adjsutedAnswers[PARTS_TO_REPLACE].filter(function (part) {
      return part !== 'engine' && part !== 'transmission' && part !== 'powertrain';
    });
  } // absOperational
  // if absOperational is false we will mark it in partsToReplace


  if (absOperational === false) {
    // we will add it to partsToReplace
    adjsutedAnswers[PARTS_TO_REPLACE].push('abs');
    adjsutedAnswers.absOperational = null;
  }

  if (anyScratches === true && (majorExteriorInteriorDamage === '' || majorExteriorInteriorDamage === false)) {
    adjsutedAnswers[MAJOR_EXTERIOR_INTERIOR_DAMAGE] = true;
  }

  return adjsutedAnswers;
};

exports.Trade360ToDeskingAnswersMapper = Trade360ToDeskingAnswersMapper;
var model = {
  iconName: 'rapport',
  sections: {
    history: history,
    susDamage: susDamage,
    repairsRequired: repairsRequired,
    registration: registration,
    addDisclosures: addDisclosures
  }
};
var _default = model;
exports.default = _default;